




















import Vue from "vue";
import { action, mutations, store } from "../services/store";
import { clickAward, withdraw } from "../services/index";
import { ACTIVITY_UID, redbagPageUrl } from "@/utils/config";
import { openScheme, getScheme } from "@/utils/openUrl";
import { IRemindPrizeItem } from "@/types";

import PrizesComp from "./PrizesComp.vue";

export default Vue.extend({
  name: "Prizes",
  components: {
    PrizesComp
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    status(): number {
      return store.status;
    },
    originalPrizeList(): IRemindPrizeItem[] {
      return store.remindPrizeList;
    },
    canExpand(): boolean {
      return this.originalPrizeList && this.originalPrizeList.length > 3;
    },
    currentPrizeList(): IRemindPrizeItem[] {
      if (this.canExpand && !this.expanded) {
        return this.originalPrizeList.slice(0, 3);
      }
      return this.originalPrizeList;
    },
    btnText(): string {
      return this.canExpand ? (this.expanded ? "收起" : "展开") : "";
    }
  },
  methods: {
    formatTime(time) {
      return new Date(time * 1000);
    },
    toggleExpand() {
      if (this.expanded) {
        const prizesContainer = this.$refs.prizes as HTMLDivElement;
        const top = prizesContainer.offsetTop;
        const nav = document.querySelector(".main .nav");
        const navHeight = nav?.getBoundingClientRect().height || 0;
        window.scrollTo({
          top: top - navHeight
        });
      }
      this.expanded = !this.expanded;
    },
    getBtnClass(item: IRemindPrizeItem) {
      const { award_type, status } = item;
      if (award_type === "Cash") {
        // 奖品类型为现金
        switch (status) {
          case 0: return "bg1";
          case 1: return "bg2";
          default: return "bg1";
        }
      } else {
        return "bg1";
      }
    },
    getBtnText(item: IRemindPrizeItem) {
      const { award_type, status, source } = item;
      // 奖品类型为拉新红包
      if (award_type === "Cash" && source === 2) {
        switch (status) {
          case 0: return "去提现";
          case 1: return "入账中";
          default: return "去提现";
        }
      } else {
        return "去查看";
      }
    },
    receivePrize(item: IRemindPrizeItem) {
      const { award_type, award_id, jump_url, status, source } = item;
      // 如果是拉新红包
      if (award_type === "Cash" && source === 2) {
        // 如果未提现
        if (status === 0) {
          withdraw({
            activity_uid: ACTIVITY_UID,
            id: +award_id
          });
          mutations.setGlobalLoading(true);
          setTimeout(() => {
            const scheme = getScheme("browser", redbagPageUrl);
            openScheme(scheme);
            action.updatePrizes();
            mutations.setGlobalLoading(false);
          }, 2000);
        }
      } else {
        // 点击“去查看”按钮上报
        clickAward(award_id);
        // 如果是其他奖品，点击“去查看”后跳转到对应链接
        if (jump_url) {
          const scheme = getScheme("browser", jump_url);
          openScheme(scheme);
        }
        action.updatePrizes();
      }
    }
  }
});
